import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { useAuth } from './context/AuthContext'
import { ThemeProvider } from './context/ThemeContext'
import Landing    from './pages/Landing'
import Login      from './pages/Login'
import Register   from './pages/Register'
import ModeSelect from './pages/ModeSelect'
import Tutorial   from './pages/Tutorial'
import Dashboard  from './pages/Dashboard'
import StockPage  from './pages/StockPage'
import SearchPage from './pages/SearchPage'
import Settings   from './pages/Settings'

function ProtectedRoute({ children }: { children: React.ReactNode }) {
  const { isLoggedIn } = useAuth()
  return isLoggedIn ? <>{children}</> : <Navigate to="/login" replace />
}

export default function App() {
  const { isLoggedIn } = useAuth()
  return (
    <ThemeProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/"        element={<Landing />} />
          <Route path="/login"   element={isLoggedIn ? <Navigate to="/dashboard" replace /> : <Login />} />
          <Route path="/register" element={<Register />} />
          <Route path="/setup"    element={<ModeSelect />} />
          <Route path="/tutorial" element={<Tutorial />} />
          <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
          <Route path="/stock/:ticker" element={<ProtectedRoute><StockPage /></ProtectedRoute>} />
          <Route path="/search"  element={<ProtectedRoute><SearchPage /></ProtectedRoute>} />
          <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </ThemeProvider>
  )
}